import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1874aabe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "instructor-feedback" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "mr-auto text-black" }, "Feedback")
], -1))
const _hoisted_3 = { class: "qualifier-container" }
const _hoisted_4 = { class: "icon-wrapper" }
const _hoisted_5 = { class: "qualifier-text" }
const _hoisted_6 = {
  key: 0,
  class: "character-count"
}
const _hoisted_7 = { class: "flex h-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Publish ")

import CheckBox from '../CheckBox.vue';
import IconComponent from '../icon/IconComponent.vue';
import Icon from '../icon/Icon';
import ButtonComponent from '../ButtonComponent.vue';
import { computed, ref } from 'vue';
import {
  Qualifier,
  instructorFeedbackQualifiers,
  getIconOrDefault,
  getTextOrDefault
} from '@/models/Qualifier';


export default /*#__PURE__*/_defineComponent({
  __name: 'InstructorFeedbackForm',
  emits: ["publish"],
  setup(__props, { emit }: { emit: ({
  (e: 'publish', message: string, qualifier: Qualifier): void;
}), expose: any, slots: any, attrs: any }) {

const MAX_CHARACTERS = 240;
const PLACEHOLDER_TEXT = `Maximum characters ${MAX_CHARACTERS}...`;
const DEFAULT_QUALIFIER = Qualifier.POSITIVE;
const message = ref('');
const selectedQualifier = ref(DEFAULT_QUALIFIER);
const qualifiers = instructorFeedbackQualifiers.map((qualifier) => {
  return {
    qualifier,
    icon: getIconOrDefault(qualifier),
    text: getTextOrDefault(qualifier)
  };
});



const characterCount = computed(() => {
  return message.value.length;
});

const maxed = computed(() => {
  return message.value.length >= MAX_CHARACTERS;
});

const isDisabled = computed(() => {
  return message.value.length < 1;
});

const clearForm = () => {
  selectedQualifier.value = DEFAULT_QUALIFIER;
  message.value = '';
};

const publishBulletin = () => {
  emit('publish', message.value, selectedQualifier.value);
  clearForm();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qualifiers), (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "qualifiers",
        key: item.qualifier
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(CheckBox, {
            class: "checkbox",
            state: selectedQualifier.value === item.qualifier,
            onClick: ($event: any) => (selectedQualifier.value = item.qualifier)
          }, null, 8, ["state", "onClick"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(IconComponent, {
              icon: item.icon
            }, null, 8, ["icon"])
          ]),
          _createElementVNode("p", _hoisted_5, _toDisplayString(item.text), 1)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", {
      class: _normalizeClass(["relative", { maxed: _unref(maxed) }])
    }, [
      (_unref(characterCount) > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(characterCount)) + "/" + _toDisplayString(MAX_CHARACTERS), 1))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("textarea", {
        rows: "7",
        maxlength: MAX_CHARACTERS,
        placeholder: PLACEHOLDER_TEXT,
        class: "message-box",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event))
      }, null, 512), [
        [_vModelText, message.value]
      ])
    ], 2),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "result-text")
    ]),
    _createVNode(ButtonComponent, {
      class: "mt-2 ml-auto",
      "color-type": "primary",
      size: "large",
      "right-icon-value": _unref(Icon).SEND_ARROW,
      onClick: publishBulletin,
      disabled: _unref(isDisabled)
    }, {
      default: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    }, 8, ["right-icon-value", "disabled"])
  ]))
}
}

})